import DayjsUtils from '@date-io/dayjs'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import Chip from '@material-ui/core/Chip'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TextField from '@material-ui/core/TextField'
import AddIcon from '@material-ui/icons/AddCircle'
import DeleteIcon from '@material-ui/icons/Delete'
import DoneIcon from '@material-ui/icons/Done'
import EditIcon from '@material-ui/icons/Edit'
import { MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers"
import React, { useState } from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import { green } from '@material-ui/core/colors';
import { useSnackbar } from 'notistack';
import { mdiHours24 } from '@mdi/js';
import Icon from '@mdi/react';

const useStyles = makeStyles({
	table: {
		minWidth: 800,
	},
});

const EditDialog = ({ OnEdit, index, geofence }) => {
	const { enqueueSnackbar } = useSnackbar();
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);
	const [rows, setRows] = useState(geofence.vehicles[index].schedule);


	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}

	const handleChange = (index, name, value) => {
		let new_rows = [...rows];
		new_rows[index][name] = value;
		setRows(new_rows);
	}

	const handleAdd = () => {
		let validated = true;
		if (rows.length < 1) {
			validated = false;
			enqueueSnackbar('Must assign atleast 1 timeslot.', { variant: 'error' });
		}
		for (const item of rows) {
			if (!item.name) {
				enqueueSnackbar('Timeslot name can not be left empty.', { variant: 'error' });
				validated = false;
			}
			if (!item.notification_on_entry && !item.notification_on_exit) {
				enqueueSnackbar('One of Entry/Exit must be enabled.', { variant: 'error' });
				validated = false;
			}
			if (item.days.length < 1) {
				enqueueSnackbar('Please select atleast one Day.', { variant: 'error' });
				validated = false;
			}
			if (item.end < item.start) {
				enqueueSnackbar('End time cannot be lower than Start time.', { variant: 'error' });
				validated = false;
			}
		}
		if (validated) {
			setOpen(false)
			const updated_geofence = geofence;
			updated_geofence.vehicles[index].schedule = rows;
			OnEdit(updated_geofence);
		}
		// console.log(updated_geofence);
	}

	const handleAddRow = () => {
		let startD = new Date();
		startD.setDate(0);
		startD.setMonth(0);
		startD.setFullYear(0);
		startD.setHours(0);
		startD.setMinutes(0);
		let endD = new Date();
		endD.setDate(0);
		endD.setMonth(0);
		endD.setFullYear(0);
		endD.setHours(23);
		endD.setMinutes(59);
		setRows(rows.concat({
			name: "24/7",
			instant: false,
			start: startD,
			end: endD,
			days: [
				"monday",
				"tuesday",
				"wednesday",
				"thursday",
				"friday",
				"saturday",
				"sunday"
			],
			notification_on_entry: true,
			notification_on_exit: true
		}));
	}

	const handleDate = (index, name, value) => {
		let new_rows = [...rows];
		// console.log(value);
		new_rows[index][name] = value;
		setRows(new_rows);
	}

	const handleDays = (index, name, value) => {
		let new_rows = [...rows];
		// console.log(value);
		if (value) {
			new_rows[index]['days'].push(name);
		} else {
			new_rows[index]['days'] = new_rows[index]['days'].filter(nr => nr !== name);
		}
		setRows(new_rows);
	}

	const handleRemove = (index) => {
		let new_rows = [...rows];
		// console.log(value);
		new_rows.splice(index, 1);
		setRows(new_rows);
	}

	return (
		<div >
			<Tooltip title='Edit this Assignment'>
				<IconButton aria-label="delete" onClick={handleClickOpen}>
					<EditIcon color="primary" />
				</IconButton>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth={'lg'}
			>
				<DialogTitle id="form-dialog-title">Add Time Slots for the geofence</DialogTitle>
				<DialogContent>
					<TableContainer>
						<Table className={classes.table} size="small" aria-label="a dense table">
							<TableHead>
								<TableRow>
									<TableCell
										align="left"
										style={{
											minWidth: 250
										}}>
										Name
									</TableCell>
									<TableCell
										align="center"
										style={{
											minWidth: 100
										}}>
										Instant
									</TableCell>
									<TableCell
										align="center"
										style={{
											minWidth: 150
										}}>
										Enter/Exit
									</TableCell>
									<TableCell
										align="center"
										style={{
											minWidth: 110
										}}
									>
										Start Time
									</TableCell>
									<TableCell
										align="center"
										style={{
											minWidth: 110
										}}
									>
										End Time
									</TableCell>
									<TableCell
										align="center"
										style={{
											minWidth: 370
										}}
									>
										Days
									</TableCell>
									<TableCell
										align="center"
										style={{
											minWidth: 90
										}}
									>
										Actions
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{rows.map((row, index) => (
									<TableRow key={`row-${index}`}>
										<TableCell component="th" scope="row">
											<TextField
												id={`name-${index}`}
												value={row.name}
												onChange={e => handleChange(index, 'name', e.target.value)}
												error={row.name ? false : true}
												helperText={row.name ? false : 'Invalid'}
												inputProps={{
													maxLength: 24
												}}
											/>
										</TableCell>
										<TableCell align="right">
											<Checkbox
												checked={row.instant}
												onChange={e => handleChange(index, 'instant', e.target.checked)}
												inputProps={{ 'aria-label': 'primary checkbox' }}
												color="primary"
											/>
										</TableCell>
										<TableCell align="right">
											<Chip
												style={{ border: '0px' }}
												label="Entry"
												clickable
												color="primary"
												variant={row.notification_on_entry ? "default" : "outlined"}
												onClick={e => handleChange(index, 'notification_on_entry', !row.notification_on_entry)}
												deleteIcon={row.notification_on_entry ? <DoneIcon /> : null}
											/>
											<Chip
												style={{ border: '0px' }}
												label="Exit"
												clickable
												color="primary"
												variant={row.notification_on_exit ? "default" : "outlined"}
												onClick={e => handleChange(index, 'notification_on_exit', !row.notification_on_exit)}
												deleteIcon={row.notification_on_exit ? <DoneIcon /> : null}
											/>
										</TableCell>
										<TableCell align="right">
											<div
												style={{ maxWidth: 70 }}
											>
												<MuiPickersUtilsProvider utils={DayjsUtils}>
													<TimePicker
														autoOk
														ampm={false}
														variant="inline"
														value={row.start}
														onChange={e => handleDate(index, 'start', e)}
													/>
												</MuiPickersUtilsProvider>
											</div>
										</TableCell>
										<TableCell align="right">
											<div
												style={{ maxWidth: 70 }}
											>
												<MuiPickersUtilsProvider utils={DayjsUtils}>
													<TimePicker
														autoOk
														ampm={false}
														variant="inline"
														value={row.end}
														onChange={e => handleDate(index, 'end', e)}
													/>
												</MuiPickersUtilsProvider>
											</div>
										</TableCell>
										<TableCell align="left">
											<Chip
												style={{ border: '0px' }}
												label="Mon"
												clickable
												color="primary"
												variant={row.days.includes('monday') ? "default" : "outlined"}
												onClick={e => handleDays(index, 'monday', !row.days.includes('monday'))}
												deleteIcon={row.days.includes('monday') ? <DoneIcon /> : null}
											/>
											<Chip
												style={{ border: '0px' }}
												label="Tue"
												clickable
												color="primary"
												variant={row.days.includes('tuesday') ? "default" : "outlined"}
												onClick={e => handleDays(index, 'tuesday', !row.days.includes('tuesday'))}
												deleteIcon={row.days.includes('tuesday') ? <DoneIcon /> : null}
											/>
											<Chip
												style={{ border: '0px' }}
												label="Wed"
												clickable
												color="primary"
												variant={row.days.includes('wednesday') ? "default" : "outlined"}
												onClick={e => handleDays(index, 'wednesday', !row.days.includes('wednesday'))}
												onDelete={null}
												deleteIcon={row.days.includes('wednesday') ? <DoneIcon /> : null}
											/>
											<Chip
												style={{ border: '0px' }}
												label="Thu"
												clickable
												color="primary"
												variant={row.days.includes('thursday') ? "default" : "outlined"}
												onClick={e => handleDays(index, 'thursday', !row.days.includes('thursday'))}
												deleteIcon={row.days.includes('thursday') ? <DoneIcon /> : null}
											/>
											<Chip
												style={{ border: '0px' }}
												label="Fri"
												clickable
												color="primary"
												variant={row.days.includes('friday') ? "default" : "outlined"}
												onClick={e => handleDays(index, 'friday', !row.days.includes('friday'))}
												deleteIcon={row.days.includes('friday') ? <DoneIcon /> : null}
											/>
											<Chip
												style={{ border: '0px' }}
												label="Sat"
												clickable
												color="primary"
												variant={row.days.includes('saturday') ? "default" : "outlined"}
												onClick={e => handleDays(index, 'saturday', !row.days.includes('saturday'))}
												deleteIcon={row.days.includes('saturday') ? <DoneIcon /> : null}
											/>
											<Chip
												style={{ border: '0px' }}
												label="Sun"
												clickable
												color="primary"
												variant={row.days.includes('sunday') ? "default" : "outlined"}
												onClick={e => handleDays(index, 'sunday', !row.days.includes('sunday'))}
												deleteIcon={row.days.includes('sunday') ? <DoneIcon /> : null}
											/>
										</TableCell>
										<TableCell align="right">
											<IconButton aria-label="delete" onClick={e => handleRemove(index)}>
												<DeleteIcon color="secondary" />
											</IconButton>
										</TableCell>
									</TableRow>
								))}
								<TableRow key={'Add Another'}>
									<TableCell align="center" colSpan={7}>
										<Tooltip title={'Add new timeslot'}>
											<IconButton aria-label="delete" onClick={handleAddRow}>
												<AddIcon style={{ color: green[500] }} />
											</IconButton>
										</Tooltip>
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleAdd} color="primary">
						Update
					</Button>
				</DialogActions>
			</Dialog>
		</div >
	)
}


export default EditDialog
